import { combine, withContext, withAsyncEffect } from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import TournamentHeaderComponent from './component'

export const TournamentHeader = combine({
	hooks: [
		withContext('tournamentsStore', StoreContext, ({ tournaments }) => tournaments),
		withAsyncEffect({
			deps: ['eventId'],
			dataName: 'event',
			loadingName: 'loading',
			errorName: 'error',
			async asyncAction({ tournamentsStore }, { eventId }) {
				try {
					// Try to get tournament data using the tournament ID
					const tournament = await tournamentsStore.loadOne(eventId)
					
					// Convert tournament data to event-like structure for compatibility
					return {
						id: tournament.id,
						tournament: tournament,
						tournamentName: tournament.tournamentName,
						startTime: tournament.startTime,
						endTime: tournament.endTime,
					}
				} catch (error) {
					throw new Error('Failed to load tournament details')
				}
			},
		}),
	],
})(TournamentHeaderComponent) 